export async function participate(request, campaign) {
    const rv = await request({
        url: "/participate/" + campaign,
        method: "post"
      });
    return rv;
}

export async function setPoints(request, points) {
    const rv = await request({
        url: "/set-points",
        method: "post",
        params: {
          points: points
        }
      });
    return rv;
}

export async function startTelVerify(request) {
  const rv = await request({
    url: "/verify-telephone",
    method: "get"
  });
  return rv;
}

export async function verifyTel(request, args) {
  const rv = await request({
    url: "/verify-telephone",
    method: "post",
    params: {
      code: args.code
    }
  });
  return rv;
}
